import { closedButtonLabel, isStoreClosed } from '../../lib/storeHoursDisplay';
import { normalizeScheduleFromApi } from '../../lib/scheduleDisplay';
import { nowInStore } from '../../lib/storeHoursDisplay';

/** Píldora «● Abierto ahora · cierra 23:00» / «● Cerrado · abrimos mañana 09:00». */
export default function StatusPill({ status, schedule, className = '' }) {
  if (!status) return null;
  const closed = isStoreClosed(status);
  let label;
  if (closed) {
    label = closedButtonLabel(status, schedule);
  } else {
    let closeAt = '';
    if (schedule) {
      const s = normalizeScheduleFromApi(schedule);
      const { isoWeekday, minutes } = nowInStore();
      const pd = s.per_day[String(isoWeekday)];
      const toMin = (t) => {
        const [h, m] = String(t || '').split(':').map(Number);
        return h * 60 + m;
      };
      const ls = toMin(pd.lunch_start);
      closeAt = minutes < ls && toMin(pd.lunch_end) > ls ? pd.lunch_start : pd.closing_time;
    }
    label = closeAt ? `Abierto ahora · cierra ${closeAt}` : 'Abierto ahora';
  }
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-sm font-semibold ${
        closed ? 'bg-[#B8321F] text-white' : 'bg-[#3F7D3A] text-white'
      } ${className}`}
      role="status"
    >
      <span className="relative flex h-2.5 w-2.5" aria-hidden="true">
        {!closed ? <span className="absolute inline-flex h-full w-full rounded-full bg-white/70 animate-ping" /> : null}
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-white" />
      </span>
      {label}
    </span>
  );
}
